"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = require("react");

var react_2 = __importDefault(require("react"));

var StyledTab = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  border: 1px solid;\n  border-color: ", ";\n  border-bottom: none;\n  bottom: -1px;\n  position: relative;\n  list-style: none;\n  padding: 6px 12px;\n  border-radius: 5px 5px 0 0;\n  cursor: pointer;\n  color: black;\n  background-color: ", ";\n"], ["\n  display: inline-block;\n  border: 1px solid;\n  border-color: ", ";\n  border-bottom: none;\n  bottom: -1px;\n  position: relative;\n  list-style: none;\n  padding: 6px 12px;\n  border-radius: 5px 5px 0 0;\n  cursor: pointer;\n  color: black;\n  background-color: ", ";\n"])), function (_a) {
  var selected = _a.selected;
  return selected ? '#aaa' : 'transparent';
}, function (_a) {
  var selected = _a.selected;
  return selected ? '#fff' : 'transparent';
});
var StyledTabPanel = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (_a) {
  var selected = _a.selected;
  return selected ? 'block' : 'none';
});
var TabContext = react_2.default.createContext({
  selectedTab: '',
  selectTab: function selectTab() {}
});
exports.TabList = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-bottom: 1px solid #aaa;\n  margin: 0 0 10px;\n  padding: 0;\n"], ["\n  border-bottom: 1px solid #aaa;\n  margin: 0 0 10px;\n  padding: 0;\n"])));

exports.Tabs = function (_a) {
  var defaultTab = _a.defaultTab,
      children = _a.children;

  var _b = react_1.useState(defaultTab),
      selectedTab = _b[0],
      setSelectedTab = _b[1];

  return react_2.default.createElement(TabContext.Provider, {
    value: {
      selectedTab: selectedTab,
      selectTab: setSelectedTab
    }
  }, children);
};

exports.Tab = function (_a) {
  var name = _a.name,
      children = _a.children;
  return react_2.default.createElement(TabContext.Consumer, null, function (context) {
    return react_2.default.createElement(StyledTab, {
      selected: context.selectedTab === name,
      onClick: function onClick(e) {
        e.preventDefault();
        context.selectTab(name);
      }
    }, children);
  });
};

exports.TabPanel = function (_a) {
  var name = _a.name,
      children = _a.children;
  return react_2.default.createElement(TabContext.Consumer, null, function (context) {
    return react_2.default.createElement(StyledTabPanel, {
      selected: context.selectedTab === name
    }, children);
  });
};

var templateObject_1, templateObject_2, templateObject_3;